export default __webpack_public_path__ + "static/media/whatsapp-grey.189a4713.svg";